import PrevDataContext from "./PrevDataContext";
import { useState,useContext } from "react";
import axios from "axios";
import LoadContext from "./LoadContext";
import { toast } from "react-hot-toast";
function PrevDataProvider({ children }) {
  const [prevData, setPrevData] = useState("");
  const [fileName, setFileName] = useState("untitled");
  const [saveButtonName, setSaveButtonName] = useState("Save");
  const [files,setFiles] = useState([]);
  const {setLoading} = useContext(LoadContext)
  async function getFile(roomId) {
    setLoading(true)
    try {
      const response = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_BACKEND_URL}/api/files/${roomId}`,
        headers: {
          "Content-Type": "application/json",
          authtoken: localStorage.getItem("authtoken"),
        },
      });
      const result = await response.data;
      setLoading(false)
      setFileName(result.file.filename);
      setPrevData(result.file.data);
      setSaveButtonName("Update");
      return result.success;
    } catch (err) {
      setLoading(false)
      return false;
    }
  }

  async function updateFile(roomId, filename, inputValue,language) {
    try {
      const response = await axios({
        method: "PUT",
        url: `${process.env.REACT_APP_BACKEND_URL}/api/files/${roomId}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          filename,
          data: inputValue,
          roomId,
          language
        }),
      });
      
      const result = await response.data;
      if (result.success) {
        setFileName(result.file.filename);
        setPrevData(result.file.data);
        setSaveButtonName("Update");
        return result.success;
      }
    } catch (error) {
        toast.error("Failed to update")
        return false;
    }
    
  }

  async function getFiles(){
    setLoading(true)
    try {
      const response = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_BACKEND_URL}/api/files`,
        headers: {
          "Content-Type": "application/json",
          "authtoken":localStorage.getItem("authtoken")
        },
      });
      const result = response.data;
      setFiles(result.files)
      console.log(result.files)
      setLoading(false)
    } catch (error) {
      console.log(error)
    }
  }

  async function deleteFile(roomId){
    try {
      const response = await axios({
        method: "DELETE",
        url: `${process.env.REACT_APP_BACKEND_URL}/api/files/${roomId}`,
        headers: {
          "Content-Type": "application/json",
          "authtoken":localStorage.getItem("authtoken")
        },
      });
      const result = response.data;
      const newArray = files.filter(file=> file.roomId !== roomId)
      setFiles(newArray)
      toast.success("File deleted successfully");
    } catch (error) {
      console.log(error)
      toast.error("something went's wrong");
    }
  }


  return (
    <PrevDataContext.Provider
      value={{
        getFile,
        fileName,
        setFileName,
        prevData,
        setPrevData,
        saveButtonName,
        setSaveButtonName,
        updateFile,
        files,
        setFiles,
        getFiles,
        deleteFile
      }}
    >
      {children}
    </PrevDataContext.Provider>
  );
}

export default PrevDataProvider;
